import classnames from 'classnames'
import type { HTMLProps } from 'react'
import React from 'react'

import styles from './Corner.module.css'

type Props = {
  absolute?: boolean
  position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
  type?: 'danger' | 'warning' | 'success' | 'info' | 'default' | 'dark' | 'none'
  rounded?: boolean
  noPadding?: boolean
} & HTMLProps<HTMLDivElement>

const Corner = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      absolute = true,
      position = 'topLeft',
      children,
      rounded = true,
      noPadding = false,
      type = 'default',
      className,
      ...other
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={classnames(className, styles.Container, {
          [styles.absolute]: absolute,
          [styles.topLeft]: position === 'topLeft',
          [styles.topRight]: position === 'topRight',
          [styles.bottomLeft]: position === 'bottomLeft',
          [styles.bottomRight]: position === 'bottomRight',
          [styles.danger]: type === 'danger',
          [styles.dark]: type === 'dark',
          [styles.warning]: type === 'warning',
          [styles.success]: type === 'success',
          [styles.info]: type === 'info',
          [styles.default]: type === 'default',
          [styles.none]: type === 'none',
          [styles.padding]: !noPadding,
          [styles.notRounded]: !rounded
        })}
        {...other}
      >
        {children}
      </div>
    )
  }
)

export default Corner
